import { get_fixed_project_folder, get_lang } from "./util";

/**
 * 获取正确域名下的链接
 */
const getDomainUrl = (source, schemaName) => {
  let lang = get_lang();
  let url = "";
  let secondFolder = ["ru", "it", "fr", "es", "de"];
  if (
    ~secondFolder.indexOf(lang) &&
    !~window.location.href.indexOf("godfootsteps")
  ) {
    url = `/${lang}/special-topic/${source}/api/${schemaName}.json`;
  } else {
    url = `/special-topic/${source}/api/${schemaName}.json`;
  }
  return url;
};

/**
 * 获取api访问连接 并且兼容多语言
 * @param schemaName
 */
const apiUri = (schemaName) => {
  if (process.env.NODE_ENV === "development") {
    if (process.env.VUE_APP_LANG === "zh") {
      return `${window.location.origin}/schema/zh${schemaName}.json`;
    } else {
      return `${window.location.origin}/schema/${process.env.VUE_APP_LANG}${schemaName}.json`;
    }
  } else {
    return getDomainUrl(get_fixed_project_folder(), schemaName);
  }
};

/**
 * 获取schema数据
 * @param schemaName
 */
const get_schema = (schemaName) => {
  return new Promise((res, rej) => {
    let ajaxUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:8888/" + apiUri(schemaName)
        : apiUri(schemaName);
    $.get(ajaxUrl)
      .then((data) => {
        res(data);
      })
      .catch((err) => rej(err));
  });
};

export { getDomainUrl, apiUri, get_schema };
